import $ from "jquery";
import {processMatchTabItemClick} from "../mc/matches/match-tab-processor";

export const clickTabsItemLink = () => {
    $(document).on("click", ".tabs__item-link", function () {
        $(this).parents('.tabs').find('.tabs__item').removeClass('tabs__item--active');
        $(this).parent().addClass('tabs__item--active');

        if ($(this).parent().parent().hasClass('match-tabs')) {
            processMatchTabItemClick($(this));

            return;
        }

        const classContent = $(this).parents('.tabs').attr('data-class-content');

        $('.' + classContent).addClass(classContent + '__hidden');
        $('#' + $(this).attr('data-id')).removeClass(classContent + '__hidden');
    });
};
